import { Component }            from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-search-form',
  standalone: true,
  imports: [
    FormsModule,
    NgIf,
    ReactiveFormsModule
  ],
  templateUrl: './search-form.component.html',
  styleUrl: './search-form.component.css'
})
export class SearchFormComponent {

  public state = 'ready';
  public form = new FormGroup({
    type: new FormControl(null, []),
    city: new FormControl(null, []),
    roomNumber: new FormControl(null, []),
    class: new FormControl(null, []),
    decoration: new FormControl(null, []),//отделка
    priceFrom: new FormControl(null, []),
    priceTo: new FormControl(null, []),
    commissionFrom: new FormControl(null, []),
    commissionTo: new FormControl(null, []),
  });

  onSubmit(): void {
    console.log('nothing')
  }
}
